import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: -1rem;
`;

interface SectionContentProps {
  isSelected?: boolean;
}

export const SectionContent = styled.section<SectionContentProps>`
  display: flex;
  align-items: center;
  flex-direction: column;

  border-bottom: 1px solid ${(props) => props.theme.newColors["gray-400"]};

  ${(props) =>
    props.isSelected &&
    css`
      border-bottom: none;
    `};
`;

export const SectionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem 0;
`;

export const ContentButton = styled.button`
  display: flex;
  align-items: center;

  width: 100%;
  height: 2.5rem;
  text-align: left;
  border: none;
  background-color: transparent;

  color: ${(props) => props.theme.newColors.black};
  font-size: ${(props) => props.theme.fontSize.XS};
  font-size: ${(props) => props.theme.fontWeight.Medium};
`;
